<ng-container *transloco="let t">
  <div class="flex py-4 ps-4 pe-6 gap-2.5 bg-[#FEFCE8] items-start">
    <img
      src="https://cdn.chipychapa.com//welle/General_site/Sidebar/Account/Account/allert.svg"
      width="24"
      height="24"
      class="pt-1" />
    <div class="flex flex-col font-normal text-sm text-mainTextLight">
      <span class="font-semibold mb-2.5">{{t('notifications.VPN.note')}}</span>
      <span>{{t('sidenav.cashier.deposit.modal.fill_profile')}}</span>
      <span>{{t('sidenav.cashier.deposit.modal.select_options')}}</span>
      <div class="hidden mL:flex gap-2.5 mt-2.5">
        <ng-container *ngTemplateOutlet="actionButtons"></ng-container>
      </div>
    </div>
  </div>
  <div class="flex mL:hidden flex-col gap-2.5 pb-4 ps-4 pe-6 bg-[#FEFCE8]">
    <ng-container *ngTemplateOutlet="actionButtons"></ng-container>
  </div>
  <ng-template #actionButtons>
    <app-main-button
      name="fill_profile"
      variant="mainButton"
      (click)="goToProfile()"
    ></app-main-button>
    <app-main-button
      name="another_deposit"
      variant="transparent"
      (click)="closeModal()"
    ></app-main-button>
  </ng-template>
</ng-container>
